import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { LEGAL, LEGAL_ROUTES } from '../data/legalContent';

const Footer = styled.footer`
  width: 100%;
  max-width: 960px;
  margin: 2rem auto 0;
  padding: 1.25rem 0.25rem 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
  z-index: 2;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem 1.25rem;
`;

const Links = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
`;

const FooterLink = styled(Link)`
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-secondary);
  transition: color 0.2s ease;

  &:hover {
    color: var(--text-primary);
  }
`;

const Disclaimer = styled.p`
  margin: 0.75rem 0 0;
  font-size: 0.78rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.45);
  max-width: 720px;
`;

const Copy = styled.span`
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.45);
`;

const SiteFooter = ({ compact = false }) => (
  <Footer>
    <Row>
      <Links aria-label="Legal and policies">
        <FooterLink to={LEGAL_ROUTES.privacy}>Privacy Policy</FooterLink>
        <FooterLink to={LEGAL_ROUTES.terms}>Terms of Service</FooterLink>
        <FooterLink to={LEGAL_ROUTES.cookies}>Storage</FooterLink>
        <FooterLink to={LEGAL_ROUTES.contact}>Contact</FooterLink>
      </Links>
      <Copy>© {new Date().getFullYear()} {LEGAL.siteName}</Copy>
    </Row>
    {!compact && (
      <Disclaimer>
        {LEGAL.siteName} is an informational founder self-assessment, not a clinical, hiring, or investment tool.
        Results are stored locally on your device unless you choose to email or share them. We do not run on-site analytics.
      </Disclaimer>
    )}
  </Footer>
);

export default SiteFooter;
